// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__fjQ91","clinicsSelect":"TableHeading_clinicsSelect__JTAEy"};